/* eslint-disable strict */

'use strict';

(async function BundleScript() {
  // Variables
  var productSelect = document.querySelector('[data-product-select]');
  var sizeSelects = Array.prototype.slice.call(document.querySelectorAll('[data-size-select]'));
  var format;
  var financeThreshold;
  var instalment12Threshold;

  // Set Default Dividebuy Pricing
  window.Simba = window.Simba || {};
  window.Simba.DivideBuy = {
    Price: ""
  };

  // Set Money Format
  format = Simba.Functional.partial(Simba.Money.format, Simba.Liquid.string('"${{amount}}"'));
  financeThreshold = Simba.Liquid.number('"35000"');
  instalment12Threshold = Simba.Liquid.number('"100000"');

  // Tooltip
  function tooltip() {
    var tt = document.getElementById('delvtooltip');
    tt.classList.toggle('show');
  }

  // Image Preload (For Swappers!)
  function preloadImage(url) {
    var img = new Image();
    img.src = url;
  }

  // Change Included Title & Copy
  function changeIncluded(variantId) {
    var elements = Array.prototype.slice.call(document.querySelectorAll('[data-bundle-included] > span'));
    var select = document.querySelector('[data-size-select].active');
    var label = select.options[select.selectedIndex].text;
    var titleElement = document.querySelector('[data-bundle-included-title]');
    var title = select.options[select.selectedIndex].getAttribute('data-title');
    if (title && title !== '') {
      titleElement.innerText = title;
    }
    elements.forEach(function (el) {
      el.style.display = 'none';
      if (el.classList.contains('listing-' + variantId) && el.getAttribute('data-label') === label) {
        el.style.display = 'block';
      }
    });
  }

  // Swap Header Image
  // eslint-disable-next-line consistent-return
  function changeHeaderImage(url) {
    var heroImg = document.querySelector('[data-bundle-hero] .first img:not([data-mobile-bg])');
    if (url.length < 1) return false;
    if (heroImg) {
      heroImg.src = url;
    }
  }

  // eslint-disable-next-line consistent-return
  function changeHeaderUrl(handle) {
    var heroLink = document.querySelector('[data-bundle-hero] .first.bundle-hero__link');
    if (handle.length < 1) return false;
    if (handle && heroLink) {
      heroLink.href = '/products/' + handle;
    }
  }

  // Swap Header Image
  // eslint-disable-next-line consistent-return
  function changePillowImage(url) {
    var heroImg = document.querySelector('[data-bundle-hero] .second img:not([data-mobile-bg])');
    if (url.length < 1) return false;
    if (heroImg) {
      heroImg.src = url;
    }
  }

  // Swap Slider Main Image
  // eslint-disable-next-line consistent-return
  function changeSliderImage(url) {
    var sliderImg = document.querySelector('[data-bundle-slider-container] [data-bundle-image] img:not(.bed-bundle)');
    if (url.length < 1) return false;
    if (sliderImg) {
      sliderImg.src = url;
    }
  }

  // Swap Initial Slide
  function changeInitialSlide(productHandle) {
    var elements = Array.prototype.slice.call(document.querySelectorAll('[data-bundle-slide] .inner'));
    elements.forEach(function (el) {
      el.style.display = 'none';
      if (el.classList.contains('slider-' + productHandle)) {
        el.style.display = 'block';
      }
    });
  }

  // Get Current Size
  function getCurrentSize(elements) {
    var size = false;
    elements.forEach(function (el) {
      if (el.classList.contains('active')) {
        size = el.options[el.selectedIndex].text;
        if (size.includes(':')) {
          size = size.substr(0, size.indexOf(':'));
        }
      }
    });
    return size;
  }

  // Swap Size Selector
  function changeSizeSelector(productHandle) {
    var elements = Array.prototype.slice.call(document.querySelectorAll('[data-size-select]'));
    var size = getCurrentSize(elements);
    var i;
    var selected = 0;
    var optionText;
    elements.forEach(function (el) {
      el.classList.remove('active');
      el.classList.add('hidden');
      if (el.classList.contains('dss-' + productHandle)) {
        for (i = 0; i < el.options.length; i++) {
          optionText = el.options[i].text;
          if (optionText.includes(':')) {
            optionText = optionText.substr(0, optionText.indexOf(':'));
          }
          if (optionText === size) {
            selected = i;
          }
        }
        el.selectedIndex = selected;
        el.classList.add('active');
        el.classList.remove('hidden');
      }
    });
  }

  // Check Whether Bundle Should Be Enabled or Disabled
  function checkEnabled(option) {
    var atcButton = document.querySelector('[data-bundle-submit]');
    if (option.disabled) {
      atcButton.disabled = true;
    } else {
      atcButton.disabled = false;
    }
  }

  // Check Whether Bundle Should Be Enabled or Disabled On First Load / Attempt To Find A Non Disabled Option
  function loadEnabler(select) {
    var atcButton = document.querySelector('[data-bundle-submit]');
    var allDisabled = true;
    var i;
    for (i = 0; i < select.length; i++) {
      if (!select.options[i].disabled) {
        select.value = select.options[i].value;
        window.Simba.Event.emit('bundle:change');
        allDisabled = false;
        break;
      }
    }
    if (allDisabled) {
      atcButton.disabled = true;
    }
  }

  // Finance Calculator Update
  function updateFinanceCalculator(total) {
    var totalRaw = parseInt(total.replace(/[^0-9]/g, ''), 10);
    var active = 'false' === 'true';
    var totals;

    var allInstalments = [3, 6, 9, 12];
    var multiplyerThreshold = parseInt('12', 10);
    var useMultiplyer = 'false' === 'true';
    var multiplyer = parseFloat('0');

    var installmentTotals = allInstalments.map(function (instalment) {
      if (instalment > multiplyerThreshold && useMultiplyer) {
        return totalRaw * multiplyer * instalment;
      }

      return totalRaw;
    });

    var installmentMonthlys = allInstalments.map(function (instalment) {
      if (instalment > multiplyerThreshold && useMultiplyer) {
        return Math.floor(totalRaw * multiplyer);
      }

      return totalRaw / instalment;
    });

    if (active) {
      totals = Array.prototype.slice.call(document.querySelectorAll('[data-finance-calculator-total]'));
      totals.forEach(function (el, idx) {
        el.innerText = format(installmentTotals[idx % 7]);
      });

      allInstalments.forEach(function (instalment, idx) {
        document.querySelector('[data-finance-calculator-instalment="' + instalment + '"]').innerText = format(installmentMonthlys[idx]);
      });

      // Hide Finance If Not Hit Threshold
      if (totalRaw < financeThreshold) {
        document.querySelector('[data-mdv-has-finance]').classList.add('hidden');
      } else {
        document.querySelector('[data-mdv-has-finance]').classList.remove('hidden');
      }

      // Hide 12 Month Installment If Not Hit Threshold
      if (totalRaw < instalment12Threshold) {
        document.querySelector('[data-finance-instalment="12"]').setAttribute('hidden', true);
        document.querySelector('[data-mdv-instalment-months]').innerText = '6';
      } else {
        document.querySelector('[data-finance-instalment="12"]').removeAttribute('hidden');
        document.querySelector('[data-mdv-instalment-months]').innerText = '12';
      }
    }

    totalRaw = totalRaw.toFixed(0) * 100;

    if (undefined !== window.simbaalma && totalRaw > 0) {
      window.simbaalma.widgets.add(window.Alma.Widgets.PaymentPlans, {
        container: '#pdp-alma',
        purchaseAmount: totalRaw,
        locale: 'fr',
        hideIfNotEligible: true,
        monochrome: false,
        plans: [
          {
            installmentsCount: 3,
            minAmount: 25000,
            maxAmount: 300000
          },
          {
            installmentsCount: 4,
            minAmount: 25000,
            maxAmount: 300000
          },
          {
            installmentsCount: 10,
            minAmount: 34900,
            maxAmount: 300000
          }
        ]
      });
    }
  }

  // Add To Cart / Bundle Submit
  // eslint-disable-next-line consistent-return
  async function submitATC(e) {
    // Variables
    var cart = Simba.AjaxCart;
    var button = document.querySelector('[data-bundle-submit]');
    var elements = Array.prototype.slice.call(document.querySelectorAll('[data-size-select]'));
    var variants = [];
    var multi;
    var props = {};
    var linePropertiesInputs = Array.prototype.slice.call(document.querySelectorAll('[data-product-line-properties] input'));
    var bedBaseSelector = document.querySelector('[data-bed-base-selector]');
    var coreVariant = false;
    let openCart = true;

    // Init
    e.preventDefault();
    if (typeof cart === 'undefined') return;
    if (button.disabled) return;
    if (button.classList.contains('submitting')) return;
    button.classList.add('submitting');

    // Set Line Item Properties
    if (linePropertiesInputs) {
      props = linePropertiesInputs.reduce(function lineProperty(acc, input) {
        var name = input.name.replace('properties[', '').replace(']', '');
        acc[name] = input.value;
        return acc;
      }, {});
    }

    // Set Core Product
    elements.forEach(function (el) {
      if (el.classList.contains('dss-' + productSelect.value)) {
        coreVariant = el.value;
        variants.push({
          id: el.value,
          quantity: 1,
          properties: props
        });
        multi = el.querySelector(':checked').getAttribute('data-multi').split(',');
      }
    });

    // Add Bed Base If Required
    if (bedBaseSelector) {
      multi.push(bedBaseSelector.value);
    }

    // Add Additional Variants
    multi.forEach(function (item) {
      var quantity = multi.filter(function (x) {
        // eslint-disable-next-line eqeqeq
        return x == item;
      }).length;
      var processed = false;
      variants.forEach(function (check) {
        if (check.id === item) {
          if (check.id === coreVariant) check.quantity += quantity;
          processed = true;
        }
      });
      if (processed) return;
      variants.push({
        id: item,
        quantity: quantity,
        properties: props
      });
    });

    /* ---------------------------------------------- */
    /* -- CRO TEST - FREE PROTECTOR FOR PRO & LUXE -- */
    /* ---------------------------------------------- */

    const croConfigContainer = document.querySelector('[data-cro-config]');
    if (croConfigContainer) {
      const croConfig = JSON.parse(croConfigContainer.innerHTML);
      const variantId = document.querySelector('.active[data-size-select]').value;
      const indexOfVariant = croConfig.bogoBuys.indexOf(variantId);
      if (indexOfVariant !== -1) {
        const bogoGetsVariant = croConfig.bogoGets[indexOfVariant];
        if (bogoGetsVariant) {
          variants.push({
            id: bogoGetsVariant[0],
            quantity: 1,
            properties: props
          });
        }
      }
    }

    /* -------------------------------------------------- */
    /* -- END CRO TEST - FREE PROTECTOR FOR PRO & LUXE -- */
    /* -------------------------------------------------- */

    // Check open cart attribute
    if (e?.currentTarget?.hasAttribute('data-form-open-cart') && e?.currentTarget?.getAttribute('data-form-open-cart') === 'false') {
      openCart = false;
    }

    // Add To Cart
    cart
      .cartAdd(variants)
      .then(function () {
        variants.forEach(async function (variant) {
          // var type = Simba.Product[variant.id].productType.toLowerCase();
          const variantData = await Simba.ProductAsync.load(variant.id);
          const type = variantData.productType.toLowerCase();

          if (type === 'mattress' || type === 'matelas' || type === 'colchon') {
            bundleGTMAddToCartEvent(variant);
          }
        });
        cart.refresh(openCart);
        button.classList.remove('submitting');
      })
      .then(function () {
        window.Simba.Event.emit('bundle-form:add-to-cart', variants);
      });
  }

  // Bundle GTM Add To Cart Event
  function bundleGTMAddToCartEvent(variant) {
    var dfd = jQuery.Deferred();
    var eventData = window.Simba.gtmConstructEventData('ProductAddToCart', variant);
    if (eventData) window.Simba.gtmPushEvent(eventData);
    dfd.resolve();
    return dfd.promise();
  }

  // Tooltip Trigger Listener
  document.getElementById('tooltipTrigger').addEventListener('click', tooltip);

  // Product Select Listener
  productSelect.addEventListener('change', function () {
    var option = this.querySelector(':checked');
    changeHeaderImage(option.getAttribute('data-image'));
    changeHeaderUrl(option.getAttribute('value'));
    changeSliderImage(option.getAttribute('data-slider'));
    changeSizeSelector(this.value);
    changeInitialSlide(this.value);
    window.Simba.Event.emit('bundle:change', this.value);
  });

  // Size Select Listener
  sizeSelects.forEach(function (ss) {
    ss.addEventListener('change', function () {
      window.Simba.Event.emit('bundle:change');
    });
  });

  // Size Select Change Event Listener
  document.addEventListener(
    'bundle:change',
    function () {
      var option = document.querySelector('[data-size-select].dss-' + productSelect.value).querySelector(':checked');
      var pricing = calculatePricing(option);
      var elementTotal = document.querySelector('[data-total]');
      var elementBundleTotal = document.querySelector('[data-bundle-total]');
      var elementMonthly = document.querySelector('[data-mdv-instalment-price]');
      var elementSavingPercentElements = document.querySelectorAll('[data-bundle-percent-saving]');
      var elementSavingTotal = document.querySelector('[data-bundle-total-saving]');
      var elementEcoTax = document.querySelector('[data-bundle-ecotax-total]');

      elementTotal.innerText = pricing.totalPrice;
      elementBundleTotal.innerText = pricing.bundlePrice;
      elementMonthly.innerText = pricing.bundleMonthly;

      if (elementEcoTax !== null) {
        elementEcoTax.innerText = pricing.bundleEcoTax;
      }

      elementSavingPercentElements.forEach(function (elementSavingPercent) {
        elementSavingPercent.innerText = pricing.bundleSavingPercent;
      });

      if (elementSavingTotal !== null) {
        elementSavingTotal.innerText = pricing.bundleSavingTotal;
      }

      Simba.DivideBuy.Price = pricing.bundlePrice.replace(',', '').replace('£', '');
      changeIncluded(option.value);
      changePillowImage(option.getAttribute('data-pillow-image'));
      updateFinanceCalculator(pricing.bundlePrice);
      checkEnabled(option);
    },
    false
  );

  // Calculate Prices
  function calculatePricing(option) {
    // Standard Pricing
    return {
      totalPrice: option.getAttribute('data-total-price'),
      bundlePrice: option.getAttribute('data-bundle-price'),
      bundleSaving: option.getAttribute('data-bundle-saving'),
      bundleMonthly: option.getAttribute('data-bundle-monthly'),
      bundleSavingPercent: option.getAttribute('data-bundle-saving-percent'),
      bundleSavingTotal: option.getAttribute('data-bundle-saving-total'),
      bundleEcoTax: option.getAttribute('data-bundle-ecotax')
    };
  }

  // Add To Cart
  document.querySelector('[data-bundle-submit]').addEventListener('click', submitATC);

  window.addEventListener('load', function () {
    if (document.getElementById('bundle')) {
      if (document.querySelector('[data-product-select]').value !== productSelect.value) {
        productSelect.value = document.querySelector('[data-product-select]').value;
      }
      productSelect.dispatchEvent(new Event('change'));
    }
  });

  // Preload Swapper Images Once DOM Ready
  document.addEventListener('DOMContentLoaded', function () {
    var elements;
    var option;

    // Change Essential To Hybrid If Selected On load
    if (productSelect.value === 'simba-hybrid-essential-mattress') {
      productSelect.value = 'mattress';
      productSelect.dispatchEvent(new Event('change'));
    }

    // Change Essential To Hybrid on France If Selected On load
    if (productSelect.value === 'le-matelas-simba-hybrid-essentiel') {
      productSelect.value = 'simba-matelas';
      productSelect.dispatchEvent(new Event('change'));
    }

    // Preload Hero & Main Slider Images
    elements = Array.prototype.slice.call(document.querySelectorAll('[data-bundle-slide] .inner picture source'));
    option = productSelect.querySelector(':not(:checked)');
    preloadImage(option.getAttribute('data-image'));
    preloadImage(option.getAttribute('data-slider'));

    // Load Inner Slider Images
    elements.forEach(function (el) {
      preloadImage(el.getAttribute('srcset'));
    });

    // Check Whether Bundle Should Be Enabled
    loadEnabler(document.querySelector('[data-size-select].dss-' + productSelect.value));
  });
})();
